module.exports = __webpack_public_path__ + "static/media/4.af3ca81f.png";